import { FacebookSVG, InstagramSvg, TelegramSVG } from "../../assets/svg";
import { Link } from "react-router-dom";
import { Image } from "antd";
import { useTranslation } from "src/i18n/context";
import { siteName } from "src/config/termConfig";

function Footer() {
  const { t } = useTranslation();
  return (
    <div className="footer">
      <div className="container">
        <div className="footer__nav">
          <div className="footer__info">
            <div className="footer__logos">
              <Link to="/" className="flex logo">
                <img
                  src={require("src/assets/images/vazirliklogooq.png")}
                  alt="HEMIS"
                />
                <span>{siteName}</span>
              </Link>
              {/* <div className="footer__logo-divider" />
              <Link to="/" className="footer__partner-logo">
                <img src="/umummilliy.png" alt="Umummilliy so'rovnoma" />
              </Link> */}
            </div>
            <p className="info">
              {t("footer.copyright")}
            </p>
          </div>
          <div className="footer__socials">
            <h4>{t("footer.socialMedia")}</h4>
            <a
              href="https://www.instagram.com/edu.uz/"
              target={"_blank"}
              rel="noreferrer"
              className="social"
            >
              <InstagramSvg />
              <span> Instagram</span>
            </a>
            <a
              href="https://t.me/eduuz"
              target={"_blank"}
              rel="noreferrer"
              className="social"
            >
              <TelegramSVG />
              <span> Telegram</span>
            </a>
            <a
              href="https://www.facebook.com/eduuzofficial"
              target={"_blank"}
              className="social"
              rel="noreferrer"
            >
              <FacebookSVG />
              <span> Facebook</span>
            </a>
          </div>
          <div className="footer__contact">
            <h4>{t("footer.contact")}</h4>
            <a href="tel:1006" style={{ color: "white" }} className="contact">
              <span>{t("footer.trustPhone")}: 1006</span>
            </a>
            {/* <a
              href="tel:+998712306464"
              style={{ color: "white" }}
              className="contact"
            >
              <PhoneSVG />
              <span>+998712306464</span>
            </a> */}
             <a
              href="https://t.me/survey_helpbot"
              target={"_blank"}
              rel="noreferrer"
              style={{ color: "white" }}
              className="contact"
            >
              {/*<TelegramSVG />*/}
              <span>{t("footer.contactFor")}: @survey_helpbot</span>
            </a>
          </div>
        </div>
        <p>{new Date().getFullYear()} © {t("footer.copyrightText")}</p>
      </div>
    </div>
  );
}

export default Footer;
